<template>
    <div class="container" id="login-page">
        <div class="row justify-content-center">
            <div v-if="!isOtp" class="col-md-8 form-login">
                <Form class="row g-3"
                      ref="loginFormRef"
                      @submit="getOtp"
                      :validation-schema="schema"
                      v-slot="{ errors }">
                    <div class="form-logo">
                        <img class="form-image" :src="'/images/LOTTE_MALL_LOGO.svg'">
                    </div>
                    <div class="form-content">
                        <div class="col-md-12 input-login">
                            <label for="inputEmail4" class="form-label">Email*</label>
                            <Field v-model="formData.email" name="email" type="text" class="form-control" :class="{ 'is-invalid': errors.email }" />
                            <div class="invalid-feedback">{{errors.email}}</div>
                        </div>
                        <div class="col-md-12 input-login">
                            <label for="inputPassword4" class="form-label">Password*</label>
                            <Field v-model="formData.password" name="password" type="password" class="form-control" :class="{ 'is-invalid': errors.password }" />
                            <div class="invalid-feedback">{{errors.password}}</div>
                        </div>
                    </div>
                    <div v-if="errorLogin.loginFalse"
                         class="form-content col-md-12 input-login text-danger">
                        {{ errorLogin.loginFalseMessage }}
                    </div>
                    <div class="col-12 div-submit">
                        <button type="submit" class="btn button-login">Get Otp</button>
                    </div>
                </Form>
            </div>
            <div v-else class="col-md-8 form-login">
                <div class="form-logo">
                    <img class="form-image" :src="'/images/LOTTE_MALL_LOGO.svg'">
                </div>
                <div class="form-content">
                    <div class="col-md-12 input-login">
                        <label for="inputEmail4" class="form-label">Otp*</label>
                        <a-input required v-model:value="otp" name="otp" type="text" class="form-control" />
                        <div style="display: contents" v-if="errorLogin.loginFalse" class="invalid-feedback">{{ errorLogin.loginFalseMessage }}</div>
                    </div>
                </div>
                <div style="margin-top: 10px" class="col-12 div-submit">
                    <button @click="login" class="btn submit-otp">Login</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Form, Field } from 'vee-validate';
import * as Yup from 'yup';
export default {
    name: "login",
    components: {
        Form,
        Field,
    },
    data() {
        const schema = Yup.object().shape({
            email: Yup.string()
                .required('Email is required')
                .email('Email is invalid'),
            password: Yup.string()
                .required('Password is required')
                .min(6, 'Password must be at least 6 characters')
        });
        return {
            schema,
            formData: {
                email: '',
                password: ''
            },
            otp: '',
            errorLogin: {
                loginFalse: false,
                loginFalseMessage: '',
            },
            sysError: {},
            isOtp: false
        }
    },
    methods: {
        ...mapActions({
            signIn: 'auth/login'
        }),
        getOtp() {
            axios.post('/admin/get-otp', {
                email: this.formData.email,
                password: this.formData.password
            }).then(response => {
                if (response.data.result) {
                    this.isOtp = true
                    this.errorLogin.loginFalse = false;
                    this.errorLogin.loginFalseMessage = ''
                } else {
                    this.sysError = response.data.error
                }
            }).catch((error) => {
                this.errorLogin.loginFalse = true;
                this.errorLogin.loginFalseMessage = 'Incorrect Email or password!'
            });
        },
        login() {
            if (this.otp) {
                axios.post('/admin/login', {
                    email: this.formData.email,
                    password: this.formData.password,
                    otp: this.otp
                }).then(response => {
                    localStorage.dataUser = JSON.stringify(response.data);
                    this.signIn()
                    this.$nextTick(() => this.$router.push('/admin/tenants'))
                    window.location.reload();
                }).catch((error) => {
                    this.errorLogin.loginFalse = true;
                    this.errorLogin.loginFalseMessage = 'Otp has expired or is incorrect!'
                });
            } else {
                this.errorLogin.loginFalse = true;
                this.errorLogin.loginFalseMessage = 'Otp is required'
            }
        }
    }
}
</script>
